<!-- 一手项目必要性文件豁免特殊坏账申请 -->
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Choose v-if='item.Property.Control=="Contact"' :data-val="item"></Choose>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'

	// import {
	// 	initWxConfig
	// } from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";

	import { getTemplateInfo,submitProcess,AllowApplyForVerify } from '@/api/approval'
	
	import {
		getRelation
	} from '@/api/employee'
	
	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	var logInfo = null;

	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				listLoading: false,
				isDisabled: false,
				formLoading: false,
				flowId:null
			}
		},
		mounted() { //页面挂载
			// initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation();
		},
		methods: { //方法
			
			getTemplate:async function() {
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				this.listLoading = true;
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程条件") {
							item.Value=-1;
							if (title.indexOf("工商铺") > -1) {
								if(jobLevel>=7){
									item.Value=0;
								}else{
									item.Value = this.getCondtion(this.relationList, 7, 1);
								}
							}
							if (title.indexOf("房友圈") > -1 || title.indexOf("藤云") > -1) {
								if(jobLevel>=8){
									item.Value=0;
								}else{
									item.Value = this.getCondtion(this.relationList, 8, 1);
								}
							}
							if (title.indexOf("二级市场营运中心") > -1 || title.indexOf("代理") > -1) {
								if(jobLevel>=8){
									item.Value=0;
								}else{
									item.Value = this.getCondtion(this.relationList, 8, 1);
								}
							}
							
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getTextVal() {
			},
			getSelectorVal(val, name) {
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				info.SummaryInfo.push({"Text":"申请部门："+control1.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "项目名称"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"项目名称："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "甲方名称"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"甲方名称："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				this.templateData.SummaryList=SummaryList
				
				
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				isSubmit = true;
				this.formLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.formLoading = false;
				});
			}
		},
		watch: {
			relationList: 'getTemplate'
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
